var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"SubMenu tw-bg-gradient2-lr tw-py-6"},[_c('div',{staticClass:"ns-container"},[_c('h1',{staticClass:"heading-white tw-text-center"},[_vm._v(" "+_vm._s(_vm.title)+" ")])])])}
var staticRenderFns = []

export { render, staticRenderFns }